<app-document-subheader></app-document-subheader>
<div class="page-container">
  <div class="card card-light w-100">
    <div class="card-body">
      <div class="container-fluid">
        <app-sales-objectives-rule-form-content />
        <app-sales-objectives-rule-tabs-details />
      </div>
    </div>
  </div>
</div>
